{
  "COMPOSE_REDIRECT": {
    "OPENING": "Nieuw gesprek met {email} openen…",
    "NO_EMAIL": "Geen e-mailadres opgegeven. Gebruik ?email=name@example.com",
    "CONTACT_ERROR": "Kan het contact voor {email} niet vinden."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Selecteer een gesprek in het linker paneel",
    "CSAT_REPLY_MESSAGE": "Beoordeel het gesprek",
    "404": "Sorry, we kunnen het gesprek niet vinden. Probeer het opnieuw",
    "SWITCH_VIEW_LAYOUT": "Wissel de lay-out",
    "DASHBOARD_APP_TAB_MESSAGES": "Berichten",
    "UNVERIFIED_SESSION": "De identiteit van deze gebruiker is niet geverifieerd",
    "NO_MESSAGE_1": "Oh oh! Het lijkt erop dat er geen berichten van klanten in uw inbox staan.",
    "NO_MESSAGE_2": " om een bericht naar uw pagina te sturen!",
    "NO_INBOX_1": "Hola! Het lijkt erop dat je nog geen postvakken hebt toegevoegd.",
    "NO_INBOX_2": " om te beginnen",
    "NO_INBOX_AGENT": "Oh Oh! Het lijkt erop dat u geen deel uitmaakt van een inbox. Neem contact op met uw beheerder",
    "SEARCH_MESSAGES": "Zoek naar berichten in gesprekken",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Vertaling",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "sneltoetsen weergeven"
    },
    "SEARCH": {
      "TITLE": "Zoek berichten",
      "RESULT_TITLE": "Zoekresultaten",
      "LOADING_MESSAGE": "Crunching data...",
      "PLACEHOLDER": "Typ een tekst om berichten te zoeken",
      "NO_MATCHING_RESULTS": "Geen resultaten gevonden."
    },
    "UNREAD_MESSAGES": "Ongelezen berichten",
    "UNREAD_MESSAGE": "Ongelezen bericht",
    "CLICK_HERE": "Klik hier",
    "LOADING_INBOXES": "Inboxen laden",
    "LOADING_CONVERSATIONS": "Conversaties laden",
    "CANNOT_REPLY": "Je kunt niet reageren omdat",
    "24_HOURS_WINDOW": "Beperking van 24-uur berichtenvenster",
    "NOT_ASSIGNED_TO_YOU": "Dit gesprek is niet aan je toegewezen. Wil je dit gesprek aan jezelf toewijzen?",
    "ASSIGN_TO_ME": "Aan mij toewijzen",
    "TWILIO_WHATSAPP_CAN_REPLY": "Je kunt dit gesprek alleen beantwoorden met een sjabloon bericht vanwege",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Beperking van 24-uur berichtenvenster",
    "REPLYING_TO": "Je antwoordt op:",
    "REMOVE_SELECTION": "Verwijder selectie",
    "DOWNLOAD": "Download",
    "UNKNOWN_FILE_TYPE": "Onbekend bestand",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Doe dit vóór verzending:",
      "EXECUTE": "Uitvoeren",
      "RETRY": "Opnieuw proberen",
      "CONFIRM": "Nu uitvoeren?",
      "CONFIRM_YES": "Ja, uitvoeren",
      "CONFIRM_NO": "Annuleren",
      "RUNNING": "Bezig…",
      "DONE": "Uitgevoerd",
      "CLAIM_DELAYED": "wordt ingediend zodra de bestelling is bezorgd",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "NIEUWE reclamatie {reference} aangemaakt, {planned} is gesloten — pas de concepttekst aan",
        "NEW_CLAIM": "NIEUWE reclamatie {reference} aangemaakt in plaats van {planned} bij te werken — pas de concepttekst aan",
        "OTHER_CLAIM": "Reclamatie {reference} bijgewerkt in plaats van {planned} — pas de concepttekst aan",
        "EXISTING_CLAIM": "Geen nieuwe reclamatie aangemaakt, de bestaande {reference} is bijgewerkt — pas de concepttekst aan",
        "OTHER": "Dit verliep anders dan het concept veronderstelde — pas de concepttekst aan"
      },
      "FAILED": "Mislukt",
      "UNREACHABLE": "De bot is niet bereikbaar",
      "REQUEST_FAILED": "De actie kon niet worden gestart, probeer het opnieuw.",
      "ACTIONS": {
        "CANCEL_ORDER": "Bestelling annuleren",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Betaling wijzigen naar rembours",
        "CREATE_CLAIM": "Reclamatie indienen",
        "CREATE_OR_UPDATE_CLAIM": "Reclamatie indienen of bijwerken",
        "EXTEND_ORDER_PICKUP_DATE": "Ophaaltermijn verlengen"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Bijlagen uploaden...",
    "REPLIED_TO_STORY": "Reageerde op jouw verhaal",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Bericht succesvol verwijderd",
    "FAIL_DELETE_MESSSAGE": "Kon bericht niet verwijderen! Probeer het opnieuw",
    "NO_RESPONSE": "Geen reactie",
    "RESPONSE": "Response",
    "RATING_TITLE": "Beoordeling",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Bericht niet beschikbaar",
    "CARD": {
      "SHOW_LABELS": "Labels weergeven",
      "HIDE_LABELS": "Labels verbergen"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Oplossen",
      "REOPEN_ACTION": "Heropenen",
      "OPEN_ACTION": "Open",
      "OPEN": "Meer",
      "CLOSE": "Sluiten",
      "DETAILS": "Details",
      "SNOOZED_UNTIL": "Snooze tot",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed tot morgen",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed tot volgende week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed tot volgende antwoord",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Markeren als in afwachting van",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Snooze tot",
        "NEXT_REPLY": "Volgende antwoord",
        "TOMORROW": "Morgen",
        "NEXT_WEEK": "Volgende week"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze tot",
      "APPLY": "Snooze",
      "CANCEL": "Annuleren"
    },
    "PRIORITY": {
      "TITLE": "Prioriteit",
      "OPTIONS": {
        "NONE": "Geen",
        "URGENT": "Dringend",
        "HIGH": "Hoog",
        "MEDIUM": "Gemiddeld",
        "LOW": "Laag"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Geen",
        "INPUT_PLACEHOLDER": "Selecteer prioriteit",
        "NO_RESULTS": "Geen resultaten gevonden",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Openen in nieuw tabblad",
      "COPY_LINK": "Link naar gesprek kopiëren",
      "COPY_LINK_SUCCESS": "Link naar gesprek gekopieerd naar klembord",
      "PENDING": "Markeren als in afwachting van",
      "RESOLVED": "Markeer als opgelost",
      "MARK_AS_UNREAD": "Markeer als ongelezen",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Heropen gesprek",
      "SNOOZE": {
        "TITLE": "Sluimeren",
        "NEXT_REPLY": "Tot volgende antwoord",
        "TOMORROW": "Tot morgen",
        "NEXT_WEEK": "Tot volgende week"
      },
      "ASSIGN_AGENT": "Agent toewijzen",
      "ASSIGN_LABEL": "Label toewijzen",
      "AGENTS_LOADING": "Agents worden geladen...",
      "ASSIGN_TEAM": "Team toewijzen",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Gesprek id {conversationId} toegewezen aan \"{agentName}\"",
          "FAILED": "Kan agent niet toewijzen. Probeer het opnieuw."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Handtekening van berichten",
      "ENABLE_SIGN_TOOLTIP": "Handtekening activeren",
      "DISABLE_SIGN_TOOLTIP": "Handtekening deactiveren",
      "MSG_INPUT": "Shift + enter voor nieuwe regel. Begin met '/' om een standaard antwoord te selecteren.",
      "PRIVATE_MSG_INPUT": "Shift + nieuwe regel invoeren. Dit is alleen zichtbaar voor medewerkers",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Berichtondertekening is niet geconfigureerd, configureer deze in de profielinstellingen.",
      "CLICK_HERE": "Klik hier om bij te werken",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "Het WhatsApp-venster van 24 uur is verlopen. Reageer met een template.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Je antwoord lijkt in het {draftLanguage} te zijn, maar dit gesprek is in het {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Vertalen",
      "REPLY": "Beantwoorden",
      "PRIVATE_NOTE": "Privénotitie",
      "SEND": "Verzenden",
      "CREATE": "Notitie toevoegen",
      "INSERT_READ_MORE": "Meer lezen",
      "DISMISS_REPLY": "Antwoord afwijzen",
      "REPLYING_TO": "Antwoord op:",
      "TIP_FORMAT_ICON": "Toon rich text editor",
      "HEADING_LEVEL": {
        "LABEL": "Tekststijl",
        "NORMAL": "Normale tekst",
        "H1": "Kop 1",
        "H2": "Kop 2",
        "H3": "Kop 3"
      },
      "EDITOR": {
        "BOLD": "Vet",
        "ITALIC": "Cursief",
        "UNDERLINE": "Onderstrepen",
        "TEXT_COLOR": "Tekstkleur",
        "BG_COLOR_LABEL": "Achtergrondkleur",
        "FONT_SIZE_LABEL": "Lettergrootte",
        "FONT_SIZE": {
          "XS": "Klein",
          "SM": "Middelklein",
          "MD": "Standaard",
          "LG": "Groot",
          "XL": "Extra groot",
          "XXL": "Enorm"
        },
        "CODE": "Code",
        "LINK": "Link toevoegen of verwijderen",
        "CREATE_LINK": "Link maken",
        "SAVE_LINK": "Opslaan",
        "CANCEL": "Annuleren",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Ongedaan maken",
        "REDO": "Opnieuw uitvoeren",
        "BULLET_LIST": "Opsommingslijst",
        "ORDERED_LIST": "Genummerde lijst",
        "BLOCKQUOTE": "Citaat",
        "H1": "Kop 1",
        "H2": "Kop 2",
        "H3": "Kop 3",
        "IMAGE_UPLOAD": "Afbeelding uploaden",
        "CLEAR_FORMATTING": "Opmaak wissen",
        "COLOR": {
          "RED": "Rood",
          "YELLOW": "Geel",
          "BLUE": "Blauw",
          "ROSE_RED": "Rozerood",
          "DEEP_CYAN": "Diep cyaan",
          "ORANGE": "Oranje",
          "PISTACHIO": "Pistache",
          "PURPLE": "Paars",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Zilver",
          "NAVY": "Marineblauw",
          "OLD_PINK": "Oudroze",
          "AQUA": "Aqua",
          "BROWN": "Bruin",
          "OLIVE": "Olijf",
          "GOLD": "Goud",
          "BEIGE": "Beige",
          "WINE": "Wijnrood",
          "FOREST": "Bosgroen",
          "GREEN": "Groen",
          "BLUE_GREY": "Blauwgrijs",
          "RUBY_RED": "Robijnrood",
          "CHESTNUT_BROWN": "Kastanjebruin",
          "ASH_GREY": "Asgrijs"
        },
        "BG_COLOR": {
          "RED": "Rood",
          "YELLOW": "Geel",
          "BLUE": "Blauw",
          "ROSE_RED": "Rozerood",
          "DEEP_CYAN": "Diep cyaan",
          "ORANGE": "Oranje",
          "PISTACHIO": "Pistache",
          "PURPLE": "Paars",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Zilver",
          "NAVY": "Marineblauw",
          "OLD_PINK": "Oudroze",
          "AQUA": "Aqua",
          "BROWN": "Bruin",
          "OLIVE": "Olijf",
          "GOLD": "Goud",
          "BEIGE": "Beige",
          "WINE": "Wijnrood",
          "FOREST": "Bosgroen",
          "GREEN": "Groen",
          "BLUE_GREY": "Blauwgrijs",
          "RUBY_RED": "Robijnrood",
          "CHESTNUT_BROWN": "Kastanjebruin",
          "ASH_GREY": "Asgrijs"
        }
      },
      "TIP_EMOJI_ICON": "Toon emoji-kiezer",
      "TIP_ATTACH_ICON": "Bestanden toevoegen",
      "TIP_AUDIORECORDER_ICON": "Audio opnemen",
      "TIP_AUDIORECORDER_PERMISSION": "Sta toegang tot audio toe",
      "TIP_AUDIORECORDER_ERROR": "Geluid kon niet worden geopend",
      "DRAG_DROP": "Sleep hierheen om toe te voegen",
      "START_AUDIO_RECORDING": "Start audio-opname",
      "STOP_AUDIO_RECORDING": "Stop audio-opname",
      "": "",
      "EMAIL_HEAD": {
        "TO": "AAN",
        "ADD_BCC": "Voeg bcc toe",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Verzenden",
          "CANCEL": "Annuleren"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Voeg een sms-inbox toe om sms-antwoorden te versturen.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privéopmerking: alleen zichtbaar voor jou en je team",
    "CHANGE_STATUS": "Gespreksstatus veranderd",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Toegewezen persoon voor dit gesprek is veranderd",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Verzonden door:",
    "BOT": "Bot",
    "SEND_FAILED": "Kon bericht niet verzenden! Probeer het opnieuw",
    "TRY_AGAIN": "opnieuw proberen",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Selecteer medewerker",
      "REMOVE": "Verwijderen",
      "ASSIGN": "Toewijzen"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiëren",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Verwijderen",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Vertaal",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Weet je zeker dat je dit bericht wilt verwijderen?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Verwijderen",
        "CANCEL": "Annuleren"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Gesprek werd gemarkeerd door {userName}",
          "CONTACT_RESOLVED": "Gesprek werd opgelost door {contactName}",
          "OPEN": "Gesprek werd heropend door {userName}",
          "PENDING": "Gesprek werd gemarkeerd als in afwachting door {userName}",
          "SNOOZED": "Gesprek werd gesluimerd door {userName}",
          "AUTO_RESOLVED": "Gesprek werd door systeem gemarkeerd als opgelost na {duration} dagen inactiviteit",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Systeem heeft het gesprek opgelost omdat het ticket op Kaufland is gesloten."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} heeft dit gesprek aan zichzelf toegewezen",
          "ASSIGNED": "Toegewezen aan {assigneeName} door {userName}",
          "REMOVED": "Gesprek niet toegewezen door {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Toegewezen aan {teamName} door {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Toegewezen aan {assigneeName} via {teamName} door {userName}",
          "REMOVED": "Unassigned from {teamName} by {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} added {labels}",
          "REMOVED": "{userName} removed {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} has muted the conversation",
        "UNMUTED": "{userName} has unmuted the conversation",
        "CONTACT_BLOCKED": "{userName} heeft het contact geblokkeerd",
        "CONTACT_UNBLOCKED": "{userName} heeft de blokkering van het contact opgeheven",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Verplaatst omdat de bestellingen van het contact alleen uit winkel {storeName} komen (laatste bestelling {orderId}), waarvan de robot in deze inbox antwoordt.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatisering is overgeslagen omdat het contact is geblokkeerd",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatisering \"{ruleName}\" kon dit gesprek niet verplaatsen van inbox {sourceInboxName} naar inbox {targetInboxName}, omdat de inboxen niet compatibel zijn.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatisering \"{ruleName}\" kon dit gesprek niet verplaatsen van inbox {sourceInboxName} naar inbox {targetInboxName}, omdat het contact geen e-mailadres heeft.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatisering \"{ruleName}\" kon geen bericht versturen: deze telefooninbox kan geen sms versturen omdat het account geen sms-inbox heeft. De regel is uitgeschakeld en de beheerders hebben een e-mail ontvangen.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatisering \"{ruleName}\" kon geen bericht versturen: vanuit deze inbox kunnen geen bijlagen per sms worden verstuurd. De regel is uitgeschakeld en de beheerders hebben een e-mail ontvangen.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macro \"{macroName}\" heeft zijn bericht niet verstuurd: deze telefooninbox kan geen sms versturen omdat het account geen sms-inbox heeft.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macro \"{macroName}\" heeft zijn bericht niet verstuurd: vanuit deze inbox kunnen geen bijlagen per sms worden verstuurd.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macro \"{macroName}\" heeft zijn bericht niet verstuurd: de bot behandelt dit gesprek. Open eerst het gesprek.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macro \"{macroName}\" heeft zijn bericht niet verstuurd: deze inbox is gemarkeerd voor verwijdering. Verplaats het gesprek eerst naar een andere inbox.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatisering \"{ruleName}\" heeft {contactEmail} een e-mail gestuurd in een nieuw gesprek [#{conversationId}]({conversationPath}) in inbox {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatisering \"{ruleName}\" heeft dit gesprek gestart vanwege gesprek [#{conversationId}]({conversationPath}) in inbox {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatisering \"{ruleName}\" kon het bericht niet versturen in een nieuw gesprek in inbox {inboxName}, omdat het contact geen e-mailadres heeft.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatisering \"{ruleName}\" heeft {contactPhone} een sms gestuurd in een nieuw gesprek [#{conversationId}]({conversationPath}) in inbox {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatisering \"{ruleName}\" kon de sms niet versturen in een nieuw gesprek in inbox {inboxName}, omdat het contact geen telefoonnummer heeft.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Klant"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "elders opgenomen, ging {duration} over",
            "NO_ANSWER": "niet opgenomen, ging {duration} over",
            "REJECTED": "geweigerd na {duration} overgaan"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automatisch opgelost na {count} mislukte terugbelpogingen",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Gespreksopname verwijderd door {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Onzichtbaar voor klant",
    "SENT_VIA_EMAIL": "Ook per e-mail naar het contact verzonden ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Deze inbox is gemarkeerd voor verwijdering, dus het antwoord van de klant zou nooit aankomen. Verplaats het gesprek naar een andere inbox om te antwoorden.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Dit contact heeft nog een open gesprek #{id}",
      "MULTIPLE": "Dit contact heeft andere open gesprekken ({count})",
      "OPEN": "Openen",
      "SHOW": "Tonen"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Vraag de klant om het WhatsApp-telefoonnummer te delen",
      "PENDING_ACTION": "Verzoek om contactgegevens in behandeling",
      "STATES": {
        "PENDING": "Wachten op contactgegevens",
        "SHARED": "Telefoonnummer gedeeld",
        "IDENTITY_CONFLICT": "Telefoonnummer moet worden gecontroleerd"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Verstuur conversatie transcript",
    "DESC": "Send a copy of the conversation transcript to the specified email address",
    "SUBMIT": "Bevestigen",
    "CANCEL": "Annuleren",
    "SEND_EMAIL_SUCCESS": "The chat transcript was sent successfully",
    "SEND_EMAIL_ERROR": "Er is een fout opgetreden, probeer het opnieuw",
    "FORM": {
      "SEND_TO_CONTACT": "Send the transcript to the customer",
      "SEND_TO_AGENT": "Send the transcript to the assigned agent",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send the transcript to another email address",
      "EMAIL": {
        "PLACEHOLDER": "Voer een e-mailadres in",
        "ERROR": "Voer een geldig e-mailadres in"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hey 👋, Welcome to {installationName}!",
    "DESCRIPTION": "Thanks for signing up. We want you to get the most out of {installationName}. Here are a few things you can do in {installationName} to make the experience delightful.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Lees onze laatste updates",
    "ALL_CONVERSATION": {
      "TITLE": "All your conversations in one place",
      "DESCRIPTION": "View all the conversations from your customers in one single dashboard. You can filter the conversations by the incoming channel, label and status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite your team members",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Assigned Agent",
    "SELF_ASSIGN": "Aan mij toewijzen",
    "TEAM_LABEL": "Toegewezen team",
    "SELECT": {
      "PLACEHOLDER": "Geen"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Contactgegevens",
      "CONVERSATION_ACTIONS": "Conversation Actions",
      "CONVERSATION_LABELS": "Labels voor gesprekken",
      "CONVERSATION_INFO": "Conversation Information",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Vorige gesprekken",
      "MACROS": "Macro's",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Afwachtend",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Maak kenmerk aan",
    "NO_RECORDS_FOUND": "Geen attributen gevonden",
    "UPDATE": {
      "SUCCESS": "Attribuut succesvol toegevoegd",
      "ERROR": "Kan het attribuut niet bijwerken. Probeer het later opnieuw"
    },
    "ADD": {
      "TITLE": "Toevoegen",
      "SUCCESS": "Attribuut succesvol toegevoegd",
      "ERROR": "Kan het attribuut niet toevoegen. Probeer het later opnieuw"
    },
    "DELETE": {
      "SUCCESS": "Attribuut succesvol verwijderd",
      "ERROR": "Attribuut verwijderen mislukt. Probeer het later opnieuw"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Attributen toevoegen",
      "PLACEHOLDER": "Attributen zoeken",
      "NO_RESULT": "Geen attributen gevonden"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "van",
    "TO": "Aan",
    "BCC": "BCC",
    "CC": "CC",
    "SUBJECT": "Onderwerp"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Geen resultaten gevonden",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Oorspronkelijke inhoud",
    "TRANSLATED_CONTENT": "Vertaalde inhoud",
    "NO_TRANSLATIONS_AVAILABLE": "Geen vertalingen beschikbaar voor deze inhoud"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Bestelnummer",
    "EXTERNAL_ID": "Externe ID",
    "PAYMENT_TYPE": "Betaalmethode",
    "PAYMENT_DATE": "Betaaldatum",
    "DELIVERY_PROVIDER": "Vervoerder",
    "EXPECTED_DATE_OF_DELIVERY": "Verwachte levering",
    "DATE_OF_DELIVERY": "Geleverd op",
    "EXPEDITION_DATE": "Verzenddatum",
    "INTERNAL_NOTE": "Winkelnotitie",
    "PACKAGE_NUMBER": "Pakket"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
